import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import "./player.css";
import ThumbnailImage from "./ThumbnailImage";

const PlayerSlide = ({
  url,
  thumbnail,
  displayFullScreen,
}: {
  url: string;
  thumbnail: string;
  displayFullScreen?: boolean;
}) => {
  const [playing, setIsPlaying] = useState<boolean>(false);

  useEffect(() => {
    if (thumbnail === "") {
      setIsPlaying(true);
    }
  }, []);

  return (
    <div
      className={displayFullScreen === undefined ? `custom-react-player` : ""}
      style={{ width: "100%", height: "100%" }}
    >
      {playing ? (
        <ReactPlayer
          width="100%"
          height="100%"
          url={url}
          playing={true}
          controls={true}
          muted={true}
          progressInterval={1000}
          config={{
            file: displayFullScreen
              ? undefined
              : {
                  attributes: {
                    controlsList: "nofullscreen",
                  },
                },
          }}
        />
      ) : (
        <ThumbnailImage
          thumbnail={thumbnail}
          onClick={() => setIsPlaying(true)}
        />
      )}
    </div>
  );
};

export default PlayerSlide;
